import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	footerTitle: {
		id: 'language-settings.manage-translations-page-footer.footer-title',
		defaultMessage: '{language} translations',
		description: 'Title for the translations footer showing the current language',
	},
	footerSubTitle: {
		id: 'language-settings.manage-translations-page-footer.footer-sub-title',
		defaultMessage:
			'{needsReviewCount, plural, =0 {Up to date} one {{needsReviewCount} section needs review} other {{needsReviewCount} sections need review}}',
		description:
			'Subtitle for the translations footer showing how many translations need review in the {needsReviewCount} placeholder',
	},
	saveButton: {
		id: 'language-settings.manage-translations-page-footer.save-button',
		defaultMessage: 'Save',
		description: 'Label for the save button',
	},
	discardButton: {
		id: 'language-settings.manage-translations-page-footer.discard-button',
		defaultMessage: 'Discard',
		description: 'Label for the discard button',
	},
	discardButtonOnModal: {
		id: 'language-settings.manage-translations-page-footer.discard-button-on-modal',
		defaultMessage: 'Discard changes',
		description: 'Label for the discard button on the modal',
	},
	cancelButton: {
		id: 'language-settings.manage-translations-page-footer.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Label for the cancel button in the discard modal',
	},
	discardModalTitle: {
		id: 'language-settings.manage-translations-page-footer.discard-modal-title',
		defaultMessage: 'Discard these changes?',
		description: 'Title for the modal to warn about discarding changes',
	},
	discardModalBody: {
		id: 'language-settings.manage-translations-page-footer.discard-modal-body',
		defaultMessage: 'Any changes you have made will be discarded.',
		description: 'Body for the modal to warn about discarding changes',
	},
	flagErrorMessage: {
		id: 'language-settings.manage-translations-page-footer.flag-error-message',
		defaultMessage: "Your current plan doesn't allow to edit the notification templates.",
		description: 'Error message to be shown for free/evaluating tenants a disabled field is edited',
	},
	genericErrorMessage: {
		id: 'language-settings.manage-translations-page-footer.generic-error-message',
		defaultMessage:
			'Something has gone wrong with your request. If symptoms persist contact your System Administrator.',
		description: 'Error message to be shown if save fails',
	},
	translationsSaveSuccess: {
		id: 'language-settings.manage-translations-page-footer.translations-save-success',
		defaultMessage: 'Translations saved successfully',
		description: 'Success message when translations are saved successfully',
	},
});
